// extracted by mini-css-extract-plugin
export const intro = "testimonials-intro-module--intro--16eh5";
export const content = "testimonials-intro-module--content--1Ps7U";